import * as React from 'react';
import { ProductPromotions } from '@grandvisionhq/products';
import { isValidAlgoliaSearchConfig, QueryAlgoliaProducts } from '@grandvisionhq/search';
import { compose, withLazyLoading } from '@grandvisionhq/utils';
import { useMeta } from '../../context/MetaContext.js';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachPageName } from '../../hooks/use-bloomreach-page-name.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsPromotion = ({ content  })=>{
    const { products =[] , productItemCompoundAlgolia =[] , supertitle ='' , title ='' , queryString , ruleContext ,  } = content;
    const promotionProducts = productItemCompoundAlgolia.length ? productItemCompoundAlgolia : products;
    const { algolia  } = useMeta();
    const pageName = useBloomreachPageName();
    // We have three promotion components: old one is using queryString, skus and ruleContext for Algolia promotion
    const query = productItemCompoundAlgolia.length ? productItemCompoundAlgolia[0].filterQuery : queryString;
    const rule = productItemCompoundAlgolia.length ? productItemCompoundAlgolia[0].ruleContext : ruleContext;
    const skus = React.useMemo(()=>promotionProducts.map(({ sku  })=>sku
        ).filter((sku)=>!!sku
        )
    , [
        promotionProducts
    ]);
    const config = React.useMemo(()=>({
            apiKey: algolia.apiKey,
            appId: algolia.appId,
            indexName: algolia.productIndex.name,
            facets: algolia.productIndex.facets
        })
    , [
        algolia
    ]);
    // Either sku's, a querystring or algolia rule needs to be specified if we want to search
    const canSearch = promotionProducts.length > 0 || !!query || !!rule;
    if (!canSearch || !title && !supertitle || !isValidAlgoliaSearchConfig(config)) {
        console.error('Error rendering CMSPromotion, missing content or invalid search configuration');
        return null;
    }
    return /*#__PURE__*/ React.createElement(QueryAlgoliaProducts, {
        algoliaConfig: config,
        skus: skus,
        queryString: query,
        ruleContext: rule
    }, (searchState)=>{
        return !searchState.hasError && /*#__PURE__*/ React.createElement(ProductPromotions, {
            products: searchState.result,
            supertitle: supertitle,
            title: title,
            isLoading: searchState.isLoading,
            renderLocation: pageName
        });
    });
};
var Promotion = compose(withLazyLoading, withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsPromotion);

export { CmsPromotion, Promotion as default };
//# sourceMappingURL=Promotion.js.map
